'use client';

/**
 * Modal Trigger Component
 *
 * Renders a clickable span that triggers a modal through context.
 * Does not render the modal itself - that's handled by the ModalProvider.
 */

import React from 'react';

import { useModal } from '../ModalContext';
import type { ModalConfig } from '../types';

interface ModalTriggerProps {
  config: ModalConfig;
  buttonHtml: string; // Changed from buttonText to preserve HTML
  className?: string;
}

export const ModalTrigger: React.FC<ModalTriggerProps> = ({ config, buttonHtml, className }) => {
  const { openModal } = useModal();

  const handleClick = () => {
    openModal(config);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <span
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      className={`cursor-pointer ${className || ''}`}
      dangerouslySetInnerHTML={{ __html: buttonHtml }}
    />
  );
};
